import React from 'react';

import { useNavigate } from 'react-router-dom';

export default function BannerPhone() {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1); // Revient à la page précédente
  };
  return (
    <div className='menu__top'>
      <img src='/img/Logo.svg' alt='test' className='menu__icon' />
      <p className='common-text menu__yoga-title'>Yoga Taranga</p>
      <div className='menu__top-croix' onClick={goBack}></div>
    </div>
  );
}
